import React, { useEffect, useState } from 'react';
import firebase from '../../../utils/firebase'
import logo1 from '../../../assets/cropped-logo_white.png'
import './LangView.scss'
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentTab } from '../../../redux/actions/adminSideMenuAction';
import Helmet from 'react-helmet'
import Pagination from "react-js-pagination";
import Alert from '../Alert';
import { setLanguageAlert } from '../../../redux/actions/adminActions';
import Paginate from '../Pagination';


const LangView = () => {

    const [langStreamUrl, setLangStreamUrl] = useState('')
    const [offset, setOffset] = useState(10)
    const [noOfPages, setNoOfPages] = useState('')
    const [pageArray, setPageArray] = useState([])
    const [noOfData, setNoOfData] = useState('')
    const [loadedData, setLoadedData] = useState([])
    const [activePage, setActivePage] = useState(1)
    const [language, setLanguage] = useState('')
    const [languageData, setLanguageData] = useState([])
    const [echange, setEchange] = useState(true)
    const [edit, setEdit] = useState(false)
    const [editId, setEditId] = useState('')
    const [langCode, setLangCode] = useState('')
    const [langAudioUrl, setLangAudioUrl] = useState('');
    const [alertMessage, setAlertMessage] = useState('')
    const [deleteId, setDeleteId] = useState('')
    const alert = useSelector(state => state.alert)
    const { languagesAlertStatus } = alert
    const [pageState, setPageState] = useState('')
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getCurrentTab('languages'))
    }, [dispatch])

    const numArr = (num) => {
        const arr = []
        for (let i = 1; i <= num ; i++) {
          arr.push(i)
        }
        return arr
      }

    useEffect(() => {
        setNoOfPages(Math.ceil((languageData.length)/10))
        setNoOfData(languageData.length)
        setOffset(10 * activePage)
        setLoadedData(languageData.slice((offset - 10), offset))
        setPageArray(numArr(noOfPages))
    }, [activePage, languageData, noOfData, noOfPages, offset])

    useEffect(() => {
        if(pageArray.length > 0) {
            document.querySelectorAll('.page-box').forEach(el => {
                el.classList.remove('active')
            })
            if(document.querySelector(`.page${activePage}`) === null) {   
                setActivePage(pageState - 1)
            } else {   
                return document.querySelector(`.page${activePage}`).classList.add('active')
            }   
        }
        
    }, [activePage, languageData, pageArray, pageArray.length, pageState])

    useEffect(() => {
        const langRef = firebase.database().ref('Languages')

        langRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            setLanguageData(eData)
        })
    }, [echange])

    useEffect(() => {
        if (languagesAlertStatus) {
            if(deleteId) {
                const langRef = firebase.database().ref('Languages').child(deleteId)
                langRef.remove()
                setEchange(!echange)
                dispatch(setLanguageAlert(false))
                setDeleteId('')
            }
            
        }
    }, [deleteId, dispatch, echange, languagesAlertStatus])

    const handleCloseEventForm = (e) => {
        e.preventDefault()
        setEdit(false)
        setEditId('')
        document.querySelector('.lang-background').classList.add('hide')
        document.querySelector('.lang-form-container').classList.add('hide')
        setLangStreamUrl('')
        setLanguage('')
        setLangCode('')
        setLangAudioUrl('')
    }

    const handleOpenEventForm = () => {
        document.querySelector('.lang-background').classList.remove('hide')
        document.querySelector('.lang-form-container').classList.remove('hide')
    }

    const handleSubmitEventForm = (e) => {
        e.preventDefault()

        if(!langStreamUrl || !language || !langAudioUrl) {
            return
        }

        const langRef = firebase.database().ref('Languages')
        let lang = {    
                language: language,
                streamUrl: langStreamUrl,
                langCode: langCode,
                audioUrl: langAudioUrl,
                updatedAtDate: '',
                createdAtDate: Date.now()
            }
        

        langRef.push(lang)

        setEchange(!echange)

        setLangStreamUrl('')
        setLanguage('')
        setLangAudioUrl('')

        document.querySelector('.lang-background').classList.add('hide')
        document.querySelector('.lang-form-container').classList.add('hide')
        setEdit(false)
        setEditId('')

    }

    const handleEventDelete = (id, name, index) => {
        setPageState(activePage)
        setDeleteId(id)
        setAlertMessage(`You are about to delete "${name} Language" \n\nNote all data for this language will be deleted! \n\nAre you sure you want to proceed?`)
        document.querySelector(`.a${id}`).classList.remove('hide')
        let elmnt = document.querySelector(".content-view");
        let y = elmnt.scrollHeight;
        document.querySelector('.admin-background').style.height = `${y + 110}px`
        document.querySelector('.admin-background').classList.remove('hide')
        
        if((index + 1) >= 4) {
            document.querySelector(`.a${id}`).scrollIntoView();   
        }
    }

    const handleEventClone = (id) => {
        const allLangRef = firebase.database().ref('Languages')
        const langRef = firebase.database().ref('Languages').child(id)
        langRef.once('value', (el) => {
            let lang = {    
                language: el.val().language,
                streamUrl: el.val().streamUrl,
                langCode: el.val().langCode,
                audioUrl: el.val().audioUrl,
                updatedAtDate: '',
                createdAtDate: Date.now()
            }
            allLangRef.push(lang)
        })
        setEchange(!echange)

    }

    const handleEventEdit = (id) => {
        setEdit(true)
        setEditId(id)
        const langRef = firebase.database().ref('Languages').child(id)
        langRef.on('value', (el) => {
            setLangStreamUrl(el.val().streamUrl)
            setLanguage(el.val().language)
            setLangCode(el.val().langCode)
            setLangAudioUrl(el.val().audioUrl)
            })

        document.querySelector('.lang-background').classList.remove('hide')
        document.querySelector('.lang-form-container').classList.remove('hide')

    
        document.querySelector(`.admin-nav`).scrollIntoView();   
        

    }

    const handleUpdateEventForm = (e, id) => {
        e.preventDefault()
        if(langAudioUrl) {
            const langRef = firebase.database().ref('Languages').child(id)
            langRef.update({
                language: language,
                streamUrl: langStreamUrl,
                langCode: langCode,
                audioUrl: langAudioUrl,
                updatedAtDate: Date.now()
            })
        } else {
            const langRef = firebase.database().ref('Languages').child(id)
            langRef.update({
                language: language,
                streamUrl: langStreamUrl,
                langCode: langCode,
                updatedAtDate: Date.now()
            })
        }
       

        document.querySelector('.lang-background').classList.add('hide')
        document.querySelector('.lang-form-container').classList.add('hide')
        setLangStreamUrl('')
        setLanguage('')
        setLangCode('')
        setEdit(false)
        setEditId('')
        setLangAudioUrl('')
    }



    return (
        <div className='lang-view events-view'>
            <Helmet htmlAttributes>
                <meta charSet="utf-8" />
                <html lang="en" />
                <title>Admin-Languages | LVZConnect</title>
                <meta name="description" content="LVZConnect Admin Languages Page" />
            </Helmet>
            <div className="top">
                <div>
                    <img src={logo1} alt="" />
                    <h3>STREAM LANGUAGES</h3>
                </div>
                
                <button onClick={handleOpenEventForm}>Add Language +</button>
            </div>
            <div className="table-container">
                <div className="table title">
                    <div className="num dd">#</div>
                    <div className="lang dd">Language</div>
                    <div className="s-url dd">Stream Url</div>
                    <div className="lang-c dd">Code</div>
                    <div className="a-url dd">Audio Url</div>
                    <div className="date-c dd">Date Created</div>
                    <div className="date-u dd">Date Updated</div>
                    <div className="l-actions dd">Actions</div>
                </div>

                {loadedData.map((el, i) => {
                    return (
                        <div className="table details">
                            <Alert message={alertMessage} eventId={el.id} action={setLanguageAlert} />
                            <div className="num dd">{i + 1 + (offset -10)}</div>
                            <div className="lang dd">{el.language}</div>
                            <div className="s-url dd">{el.streamUrl}</div>
                            <div className="lang-c dd">{el.langCode}</div>
                            <div className="a-url dd">{el.audioUrl}</div>
                            <div className="date-c dd">{new Date(el.createdAtDate).toLocaleString()} </div>
                            <div className="date-u dd">{!el.updatedAtDate? 'Not Updated Yet' : new Date(el.updatedAtDate).toLocaleString()}</div>
                            <div className="l-actions dd">
                                <button className='delete' title='Delete' onClick={()=> handleEventDelete(el.id, el.language, i)}><i class="fas fa-trash-alt"></i></button>
                                <button className='edit' title='Edit' onClick={()=> handleEventEdit(el.id)}><i class="fas fa-edit"></i></button>
                                <button className='clone' title='Clone' onClick={() => handleEventClone(el.id)}><i class="far fa-copy"></i></button>
                            </div>
                        </div>
                    )
                })}
            </div>

            {loadedData.length > 0? 
                <Paginate activePage={activePage} setActivePage={setActivePage} pageArray={pageArray} noOfPages={noOfPages} />  : 
                ''
            }

            

            

            

            <div className='lang-form-container hide'>
                <div className="form-close" onClick={handleCloseEventForm}>
                    <i class="fas fa-times"></i>
                </div>
                <h3>
                    {edit? 'Edit Language' : 'Add New Language'}
                </h3>

                <form action="">
                    <div className="form-element">
                        <label htmlFor="language">Language</label>
                        <input required type="text" id='language' name='language' className='field' 
                        value={language} onChange={(e) => setLanguage(e.target.value)}/>
                    </div>

                    <div className="form-element">
                        <label htmlFor="langStreamUrl">Stream url</label>
                        <input type="text" id='langStreamUrl' name='langStreamUrl' className='field'  required
                        value={langStreamUrl} onChange={(e) => setLangStreamUrl(e.target.value)}/>  
                    </div>

                    <div className="form-element">
                        <label htmlFor="langAudioUrl">Audio url</label>
                        <input type="text" id='langAudioUrl' name='langAudioUrl' className='field'  required
                        value={langAudioUrl} onChange={(e) => setLangAudioUrl(e.target.value)}/>  
                    </div>

                    <div className="form-element">
                        <label htmlFor="langCode">Lang Code</label>
                        <input type="text" id='langCode' name='langCode' className='field'  required
                        value={langCode} onChange={(e) => setLangCode(e.target.value)}/>  
                    </div>

                    <div className="buttons">
                        <button className="close" onClick={handleCloseEventForm}>Close</button>
                        {edit? <button type="submit" className='submit' onClick={(e) => handleUpdateEventForm(e, editId)}>Update Event</button> : <button type="submit" className='submit' onClick={handleSubmitEventForm}>Save Event</button>}
                        
                    </div>

                    
                </form>
            </div>
        </div>
    )
}

export default LangView